export default __webpack_public_path__ + "static/Daydreams-fd03d0c231bbcfe9c7a7645418ae8402.png";